import { useFormikContext } from "formik"
import { useAppLocalization } from "../../../../../modules/localization/components/AppLocalizationProvider"
import { attendeeInitValues, CreateUpdateAttendeesForm } from "./attendeesForm/CreateUpdateAttendeesForm"
import { DynamicConfigKey, DynamicMainFormValues } from "../../../createOrder/components/form/formTypes"
import { CreateUpdateAttendeesFormValues } from "./attendeesForm/attendeesTypes"

export function AttendeesFormPart() {
    const { l10n } = useAppLocalization()

    const { values, setFieldValue, handleSubmit } = useFormikContext<DynamicMainFormValues>()
    const handleChangeAttendees = (attendeesList: CreateUpdateAttendeesFormValues) => {
        setFieldValue(DynamicConfigKey.ADD_PARTICIPANTS_FORM, [...attendeesList.attendees])
        handleSubmit()
    }

    return (
        <>
            <CreateUpdateAttendeesForm
                initialValues={{ attendees: values[DynamicConfigKey.ADD_PARTICIPANTS_FORM] || [attendeeInitValues] }}
                handleChangeAttendees={handleChangeAttendees}
                submitButtonText={l10n.getString("create-order-confirm-booking-dialog-submit-button")}
            />
        </>
    )
}
